import { render, staticRenderFns } from "./CommonToggleButton.vue?vue&type=template&id=2f61b849&lang=pug&"
import script from "./CommonToggleButton.vue?vue&type=script&lang=ts&"
export * from "./CommonToggleButton.vue?vue&type=script&lang=ts&"
import style0 from "./CommonToggleButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports